import { Button } from "@material-ui/core"
import { ReactComponent as ExpandIcon } from "assets/expand.svg"

export function ExpandButton({ onClick }: { onClick: () => void }) {
  return (
    <Button
      style={{
        minWidth: 0,
        display: "flex",
        justifyContent: "right",
        paddingRight: 0,
      }}
      onClick={onClick}
    >
      <ExpandIcon />
    </Button>
  )
}
